import React, { memo, useState } from "react";

import { DefaultTheme } from "styled-components";
import * as themes from "../assets/theme.json";
import { GlobalStyles } from "../GlobalStyles";
export enum ThemeEnum {
  LIGHT = "light",
  DARK = "dark",
}

type ThemeContextProps = {
  theme: DefaultTheme;
  changeMode: (mode: ThemeEnum) => void;
};

const defaultValue = {
  theme: themes.data.light,
  changeMode: () => void 0,
};

const SelectThemeContext = React.createContext<ThemeContextProps>(defaultValue);

const SelectThemeProvider: React.FC = memo(({ children }) => {
  const [theme, setTheme] = useState(themes.data.light);
  const changeMode = (mode: ThemeEnum) => {
    if (mode === ThemeEnum.DARK) {
      setTheme(themes.data.dark);
    } else {
      setTheme(themes.data.light);
    }
  };
  return (
    <SelectThemeContext.Provider value={{ theme, changeMode }}>
      <GlobalStyles theme={theme} />
      {children}
    </SelectThemeContext.Provider>
  );
});

const useSelectTheme = () => React.useContext(SelectThemeContext);
export { SelectThemeProvider, useSelectTheme };
